const state = {
    emailBundleIds: []
};

const getters = {
    emailBundleIds: state => state.emailBundleIds
};

const mutations = {
    setEmailBundleIds: (state, data) => state.emailBundleIds = data
};

const actions = {
    getEmailBundleIds: (context) => {
        context.commit("setEmailBundleIds", JSON.parse(window.localStorage.getItem('emailBundleIds')) ?? []);
    },
    saveEmailBundleIds: (context) => {
        window.localStorage.setItem('emailBundleIds', JSON.stringify(context.getters["emailBundleIds"]));
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    strict: false
};